import { render, staticRenderFns } from "./TemplateDetails.vue?vue&type=template&id=b0e06972&"
import script from "./TemplateDetails.vue?vue&type=script&lang=ts&"
export * from "./TemplateDetails.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateDetails.vue?vue&type=style&index=0&id=b0e06972&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports